import { render, staticRenderFns } from "./block-other-party-repairer-quote.vue?vue&type=template&id=3123acff&scoped=true&"
import script from "./block-other-party-repairer-quote.vue?vue&type=script&lang=js&"
export * from "./block-other-party-repairer-quote.vue?vue&type=script&lang=js&"
import style0 from "./block-other-party-repairer-quote.vue?vue&type=style&index=0&id=3123acff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123acff",
  null
  
)

export default component.exports